// src/utils/dates.js
import { formatDistanceToNow, isPast, isWithinInterval, addDays, parseISO } from "date-fns";

export function auditStatus(nextAuditDue) {
  if (!nextAuditDue) return "unknown";
  const due = parseISO(nextAuditDue);
  if (isPast(due)) return "overdue";
  if (isWithinInterval(new Date(), { start: new Date(), end: addDays(due, 0) }) &&
      due <= addDays(new Date(), 14)) return "due-soon";
  return "ok";
}

export function formatDue(nextAuditDue) {
  if (!nextAuditDue) return "Not set";
  const due = parseISO(nextAuditDue);
  const dist = formatDistanceToNow(due, { addSuffix: true });
  return dist;
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric", month: "short", year: "numeric",
  });
}

export function addMonths(date, months) {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d.toISOString();
}

// URL helper — only render as a link if it starts with http:// or https://
export function isWebUrl(url) {
  return typeof url === "string" && /^https?:\/\//i.test(url.trim());
}

export function formatUrl(url) {
  if (!url) return null;
  return isWebUrl(url) ? url.replace(/^https?:\/\//i, "") : url;
}
